<div class="gauge-card" [class.compact-mode]="shouldUseCompactLayout">
    <div class="gauge-chart">
        <ag-gauge [options]="options"></ag-gauge>
    </div>
    
    <div class="gauge-info">
        <!-- Year Target Row -->
        <div class="gauge-target-container">
            <div class="gauge-target-inline">
                {{ currentYear }} Target: {{ formatValue(currentYearTarget) }} {{ label }}
                <!--<span *ngIf="showPercentChange" class="change-indicator-inline" [ngClass]="{'positive-change': percentChangeTargetYearOverYear > 0, 'negative-change': percentChangeTargetYearOverYear < 0}">
                    <span class="change-value">{{ percentChangeTargetYearOverYear > 0 ? '+' : '' }}{{ formatPercentage(percentChangeTargetYearOverYear) }}</span>
                    <i class="bi" [ngClass]="percentChangeTargetYearOverYear > 0 ? 'bi-arrow-up' : 'bi-arrow-down'"></i>
                </span>-->
            </div>
        </div>

        <!-- Monthly Target Row -->
        <div class="gauge-target-container">
            <div class="gauge-target-inline">
                YTD Target: {{ formatValue(monthTarget) }} {{ label }}
                <span *ngIf="showPercentChange" class="change-indicator-inline" [ngClass]="{'positive-change': percentChangeActualVsTarget > 0, 'negative-change': percentChangeActualVsTarget < 0}">
                    <span class="change-value">{{ percentChangeActualVsTarget > 0 ? '+' : '' }}{{ formatPercentage(percentChangeActualVsTarget) }}</span>
                    <i class="bi" [ngClass]="percentChangeActualVsTarget > 0 ? 'bi-arrow-up' : 'bi-arrow-down'"></i>
                </span>
            </div>
        </div>
        
        <!-- Actual Value Row 
        <div class="year-actual-row">
            <span class="year-actual">{{ formatValue(value) }} {{ label }}</span>
            <span class="change-indicator-inline" [ngClass]="getChangeIndicatorClass()" *ngIf="showChangeIndicator">
                <i class="bi" [ngClass]="getChangeIcon()"></i>
                <span class="change-value">{{ formatChangeValue(change) }}</span>
            </span>
        </div>-->
    </div>
</div> 